import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'

const HeadTitle = ({ children, ...props }) => (
  <Title {...props}>{children}</Title>
)

const Title = styled(Typography)`
  font-weight: ${Styles.fontWeight.bold};
  line-height: ${Styles.lineHeight[300]};
  letter-spacing: ${Styles.letterSpacing[400]};
  color: ${Styles.color.primary[400]};
  margin: 0 0 ${Styles.spacing[10]} 0;
  font-size: ${Styles.fontSize[600]};
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    font-size: ${Styles.fontSize[700]};
  }
`

export default HeadTitle
